export const findClosingBracketIndex = (text: string, pos: number): number => {
  if (text[pos] !== '[') {
    throw new Error('The position must contain an opening bracket')
  }

  let level = 1
  for (let index = pos + 1; index < text.length; index++) {
    if (text[index] === '[') {
      level++
    } else if (text[index] === ']') {
      level--
    }

    if (level === 0) {
      return index
    }
  }
  return -1
}
